import { setupWorker } from 'msw'
import { setupServer } from 'msw/node'
import { shouldUseMockServer } from 'utils/environment'
import accountHandlers from '../account/handlers'
import advertisersHandlers from '../advertisers/handlers'
import applicationHandlers from '../application/handlers'
import authHandlers from '../auth/handlers'
import testCallBackUrlHandlers from '../callback-url/handlers'
import categoryFilterHandlers from '../category-filter/handlers'
import demandBlockingsHandlers from '../demand-blockings/handlers'
import experimentHandlers from '../experiments/handlers'
import placementHandlers from '../placement/handlers'
import productsHandlers from '../products/handlers'
import publisherHandlers from '../publisher/handlers'
import vcsHandlers from '../virtual-currency-sale/handlers'
import virtualCurrencyHandlers from '../virtual-currency/handlers'

if (shouldUseMockServer()) {
  const handlers = [
    ...advertisersHandlers,
    ...productsHandlers,
    ...authHandlers,
    ...accountHandlers,
    ...categoryFilterHandlers,
    ...demandBlockingsHandlers,
    ...placementHandlers,
    ...applicationHandlers,
    ...publisherHandlers,
    ...virtualCurrencyHandlers,
    ...testCallBackUrlHandlers,
    ...vcsHandlers,
    ...experimentHandlers,
  ]

  if (global.window) {
    const worker = setupWorker(...handlers)
    worker.start()
  } else {
    const server = setupServer(...handlers)
    server.listen()
  }
}
